import React from 'react'
import 'react-day-picker/lib/style.css'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { DayPickerInputProps, LocaleUtils } from 'react-day-picker'
import dayjs from 'dayjs'
import { FormControl } from 'react-bootstrap'

const getFirstDayOfWeek = (locale?: string) => {
  return 1
}

const formatDay = (d: Date, locale?: string) => {
  return dayjs(d).format('DD.MM.YYYY')
}

const formatMonthTitle = (d: Date, locale?: string) => {
  return dayjs(d).format('MMMM')
}

const formatWeekdayShort = (weekday: number, locale?: string) => {
  return dayjs.weekdaysShort()[weekday]
}

const formatWeekdayLong = (weekday: number, locale?: string) => {
  return dayjs.weekdays()[weekday]
}

const localeUtils: Partial<LocaleUtils> = {
  formatDay,
  formatMonthTitle,
  formatWeekdayShort,
  formatWeekdayLong,
  getFirstDayOfWeek,
}

const DatePicker: React.FC<DayPickerInputProps> = ({
  dayPickerProps,
  ...props
}: DayPickerInputProps): React.ReactElement => {
  return (
    <>
      <DayPickerInput
        placeholder="DD.MM.ÁÁÁÁ"
        formatDate={formatDay}
        component={FormControl}
        style={{
          width: '100%',
        }}
        dayPickerProps={{
          ...dayPickerProps,
          localeUtils: {
            ...LocaleUtils,
            ...localeUtils,
          },
        }}
        {...props}
      />
    </>
  )
}

export default DatePicker
